import React from 'react';
import Reveal from './Reveal';

const DEFAULT_STEPS = [
  { title: 'سجّل منشأتك', description: 'أنشئ حساب المنشأة وابدأ تجربة 30 يومًا.' },
  { title: 'أضف بياناتك', description: 'أضف اللاعبين والموظفين والفرق أو استوردها عبر Excel.' },
  { title: 'ابدأ الإدارة', description: 'تابع الاشتراكات والحضور والمالية والتدريبات والتقارير.' },
];

export const LandingHowItWorks = ({ landing }) => {
  const steps = Array.isArray(landing?.how_it_works_steps) && landing.how_it_works_steps.length
    ? [...landing.how_it_works_steps].sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    : DEFAULT_STEPS;

  return (
    <section id="how-it-works" className="mx-auto max-w-7xl px-5 py-24 md:py-32" data-testid="landing-how-it-works">
      <Reveal>
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-bold uppercase tracking-wider text-teal-400">كيف تعمل</span>
          <h2 className="font-display mt-3 text-2xl font-bold text-white sm:text-3xl lg:text-4xl" data-testid="landing-how-it-works-title">
            {landing?.how_it_works_title || 'كيف تعمل تسيار؟'}
          </h2>
          <p className="mt-3 text-slate-400" data-testid="landing-how-it-works-subtitle">
            {landing?.how_it_works_subtitle || 'ثلاث خطوات بسيطة لبدء إدارة منشأتك'}
          </p>
        </div>
      </Reveal>

      <div className="relative mt-14 grid grid-cols-1 gap-8 sm:grid-cols-3">
        <div className="absolute inset-x-0 top-6 hidden h-px bg-gradient-to-l from-transparent via-teal-500/30 to-transparent sm:block" />
        {steps.map((s, i) => (
          <Reveal key={i} delay={i * 100}>
            <div className="relative flex flex-col items-center text-center" data-testid={`landing-how-it-works-step-${i}`}>
              <div className="font-display relative z-10 flex h-12 w-12 items-center justify-center rounded-full border border-teal-500/40 bg-[#0A192F] text-lg font-black text-teal-400">
                {i + 1}
              </div>
              <h3 className="font-display mt-4 text-base font-bold text-white">{s.title}</h3>
              <p className="mt-2 max-w-xs text-sm leading-relaxed text-slate-400">{s.description}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default LandingHowItWorks;
